// eslint-disable-next-line import-helpers/order-imports
import FullCalendar, {
  DatesSetArg,
  EventSourceInput,
} from '@fullcalendar/react';
import ptBr from '@fullcalendar/core/locales/pt-br';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { DateTime } from 'luxon';
import React, { useMemo, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import { useRecuperarIndisponibilidadesQuery } from 'View/Service/Default/Indisponibilidades';

const Default = (): React.ReactElement => {
  const navegacao = useNavigate();
  const [intervalo, setIntervalo] = useState<Array<string>>([]);
  const ref = useRef<FullCalendar>(null);

  const { data: { indisponibilidades } = {} } =
    useRecuperarIndisponibilidadesQuery(
      {
        contain: ['Usuarios'],
        limit: 200,
        options: {
          data_e_tempo: { inicio: intervalo },
        },
      },
      { skip: intervalo.length == 0 }
    );

  const eventos = useMemo((): EventSourceInput => {
    const eventos: EventSourceInput = [];

    indisponibilidades?.map((indisponibilidade) =>
      eventos.push({
        title: indisponibilidade.usuario?.nome,
        start: indisponibilidade.inicio,
        end: indisponibilidade.termino,
        allDay: indisponibilidade.dia_inteiro as unknown as boolean,
        extendedProps: indisponibilidade,
        color:
          indisponibilidade.aprovado == null
            ? '#3788D8'
            : indisponibilidade.aprovado
            ? '#54eeae'
            : '#f77187',
      })
    );

    return eventos;
  }, [indisponibilidades]);

  const mudarData = async (evento: DatesSetArg): Promise<void> => {
    setIntervalo([
      DateTime.fromJSDate(evento.start).toFormat('yyyy-LL-dd\'T\'00:00'),
      DateTime.fromJSDate(evento.end).toFormat('yyyy-LL-dd\'T\'23:59'),
    ]);
  };

  return (
    <LayoutDefault>
      <div className="m-n4 p-4" style={{ backgroundColor: '#DDDDDD' }}>
        <FullCalendar
          ref={ref}
          locale={ptBr}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          themeSystem="bootstrap5"
          customButtons={{
            adicionar: {
              text: 'Solicitar folga',
              click: () => navegacao('/indisponibilidades/adicionar'),
            },
            aprovar: {
              text: 'Para aprovar',
              click: () => navegacao('/indisponibilidades/aguardando'),
            },
          }}
          headerToolbar={
            !isMobile
              ? {
                  left: 'prev,next today',
                  center: 'title',
                  right: 'aprovar adicionar',
                }
              : {
                  left: 'prev,next',
                  center: '',
                  right: 'aprovar adicionar',
                }
          }
          editable={false}
          selectable={false}
          events={eventos}
          // eventClick={(event) => {
          //   if (event.view.type != 'timeGridWeek') {
          //     ref.current?.getApi().changeView('timeGridWeek', event.event.start);
          //   } else {
          //     ref.current?.getApi().changeView('dayGridMonth', event.event.start);
          //   }
          // }}
          dateClick={(event) => {
            if (isMobile) {
              if (event.view.type != 'timeGridDay') {
                ref.current?.getApi().changeView('timeGridDay', event.date);
              } else {
                ref.current?.getApi().changeView('dayGridMonth', event.date);
              }
            } else {
              if (event.view.type != 'timeGridWeek') {
                ref.current?.getApi().changeView('timeGridWeek', event.date);
              } else {
                ref.current?.getApi().changeView('dayGridMonth', event.date);
              }
            }
          }}
          datesSet={mudarData}
          eventContent={(evento) => {
            const color =
              evento.event.extendedProps.aprovado == null
                ? '#3788D8'
                : evento.event.extendedProps.aprovado
                ? '#54eeae'
                : '#f77187';
            // const color =
            //   evento.event.extendedProps.aprovado == null
            //     ? '#f77187'
            //     : '#3788D8';

            return (
              <div className="text-truncate px-2 text-white text-shadow">
                <span
                  style={{
                    display: 'block',
                    backgroundColor: color,
                    borderRadius: 5,
                    padding: 5,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                >
                  {evento.event.extendedProps.tipo == 1 && (
                    <Icone nome="emoji-sunglasses-fill" className="me-2" />
                  )}
                  {evento.event.extendedProps.tipo == 2 && (
                    <Icone nome="sun-fill" className="me-2" />
                  )}
                  {evento.event.extendedProps.tipo == 3 && (
                    <Icone nome="hospital-fill" className="me-2" />
                  )}
                  {evento.event.extendedProps.usuario.nome}
                  <br />
                  <small className="fw-bold text-body">
                    {evento.event.extendedProps.motivo}
                  </small>
                </span>
              </div>
            );
          }}
          height={isMobile ? window.innerHeight - 160 : 850}
        />
      </div>
    </LayoutDefault>
  );
};

export default Default;
